module.exports = __webpack_public_path__ + "static/overview-dark-574a7d6f702214995a2debb5ed42ad07.png";